(function () {
  if (!document.getElementById('ReCharge')) return;

  var NOTICE_ID = 'mow-resiliation-notice';

  function injectResiliationNotice() {
    if (document.getElementById(NOTICE_ID)) return;

    var recharge = document.getElementById('ReCharge');
    if (!recharge) return;

    var wrapper = document.createElement('div');
    wrapper.id = NOTICE_ID;
    wrapper.style.cssText = 'padding: 1.5rem; text-align: center;';
    wrapper.innerHTML =
      '<p>Si vous disposiez d\'un abonnement avant la migration du site, vous pouvez l\'annuler en vous rendant sur ' +
      '<a href="/pages/resiliation-stripe" style="text-decoration: underline; color: blue">la page de résiliation suivante</a>.</p>' +
      '<p style="margin-top: 0.75rem;">Ou vous pouvez <a href="/account" style="text-decoration: underline;">retourner sur votre compte</a></p>';

    recharge.appendChild(wrapper);
  }

  injectResiliationNotice();

  var observer = new MutationObserver(injectResiliationNotice);
  observer.observe(document.body, { childList: true, subtree: true });
})();
